import { ReactNode } from 'react';

import { ProductFeatureName } from 'dashboard/models/organization';
import useProductFeature from 'lib/hooks/useProductFeature';

interface ProductFeatureGatedProps {
  productFeatureFlag: ProductFeatureName;
  children: ReactNode;
  fallback?: ReactNode;
  /**
   * Invert the product feature flag check. If true, the children will be rendered when the product feature flag is not enabled.
   */
  invert?: boolean;
}

const ProductFeatureGated = ({
  children,
  productFeatureFlag,
  fallback = null,
  invert = false,
}: ProductFeatureGatedProps) => {
  const hasProductFeatureFlag = useProductFeature(productFeatureFlag);

  return <>{hasProductFeatureFlag !== invert ? children : fallback}</>;
};

export default ProductFeatureGated;
